import { CommonState, Fetcher, FetchHelper } from '@primeit/components-vue';
import { secureFetch } from '@dav/security-component-spa';

const fetchHelper = new FetchHelper();
const module = {
  actions: {
    FETCH_ALL_CUSTOM_MESSAGES: async (context, params) => {
      if (!params) {
        params = {};
      }
      const response = await fetchHelper.fetchAll(
        `${process.env.VUE_APP_SERVICES_ENDPOINT_BASE_COMPANY}/${params.id}/custommessage`,
        params,
        true
      );
      context.commit('POPULATE_ALL_CUSTOM_MESSAGES', response);
    },
    FETCH_LIST_PARENTS_COMPANY: async (context, params) => {
      let response;
      let json;

      try {
        response = await Fetcher(
          `${process.env.VUE_APP_SERVICES_ENDPOINT_BASE_COMPANY}/${params.companyId}/haas/parent`
        );
        if (response.ok) {
          json = await response.json();
        }
      } catch (e) {
        json = {
          code: 400,
          message: 'Impossível acessar o servidor. Tente novamente',
        };
      }

      context.commit('POPULATE_PARENTS_COMPANY', json.parents);
    },
    FETCH_SETTINGS: async (context, params) => {
      let response, json;

      try {
        response = await Fetcher(`${process.env.VUE_APP_SERVICES_ENDPOINT_BASE_COMPANY}/${params}/settings`, {
          headers: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
          },
          method: 'GET',
        });

        json = await response.json();
      } catch (e) {
        json = {
          code: 400,
          message: 'Impossível acessar o servidor. Tente novamente',
        };
      }

      context.commit('POPULATE_SETTINGS', json);
    },
    FETCH_CAMPAIGN: async (context, params) => {
      try {
        const response = await secureFetch(
          `${process.env.VUE_APP_SERVICES_ENDPOINT_BASE_COMPANY}/onboarding/${params.permalink}`,
          {
            headers: {
              'x-company-id': params.companyId,
            },
            method: 'GET',
          }
        );

        let json = await response.json().catch(() => null);

        json = json ?? {
          code: response?.status || 400,
          message: 'Impossível acessar o servidor. Tente novamente',
        };

        context.commit('POPULATE_CAMPAIGN', json);
        return json;
      } catch (e) {
        const errorJson = {
          code: 400,
          message: 'Impossível acessar o servidor. Tente novamente',
        };
        context.commit('POPULATE_CAMPAIGN', errorJson);
        return errorJson;
      }
    },
    FETCH_REGISTER: async (context, params) => {
      const RETRYABLE_STATUS = new Set([502, 503, 504]);
      const MAX_ATTEMPTS = 4;

      for (let attempt = 1; attempt <= MAX_ATTEMPTS; attempt += 1) {
        try {
          const response = await secureFetch(
            `${process.env.VUE_APP_SERVICES_ENDPOINT_BASE_COMPANY}/onboarding/register`,
            {
              body: JSON.stringify({
                permalink: params.permalink,
                ...params.entityToSave,
              }),
              headers: {
                Accept: 'application/json, text/plain, */*',
                'Content-Type': 'application/json',
                'x-company-id': params.companyId,
              },
              method: 'POST',
            }
          );

          if (RETRYABLE_STATUS.has(response?.status) && attempt < MAX_ATTEMPTS) {
            continue;
          }

          if (response.ok) {
            return await response.json();
          }

          const json = await response.json().catch(() => null);
          return (
            json ?? {
              code: response.status || 400,
              message: 'Impossível cadastrar. Tente novamente',
            }
          );
        } catch (e) {
          if (attempt < MAX_ATTEMPTS) continue;

          return {
            code: 400,
            message: 'Impossível cadastrar. Tente novamente',
          };
        }
      }
    },
  },
  getters: {
    GET_ALL_CUSTOM_MESSAGES: (state) => {
      return JSON.parse(JSON.stringify(state.customMessages));
    },
    GET_CAMPAIGN: (state) => {
      return state.campaign;
    },
    GET_PARENTS_COMPANY: (state) => {
      return JSON.parse(JSON.stringify(state.parents_company));
    },
    GET_SETTINGS: (state) => {
      return state.settings;
    },
  },
  mutations: {
    POPULATE_ALL_CUSTOM_MESSAGES: (state, payload) => {
      if (payload) {
        state.customMessages = payload;
      }
    },
    POPULATE_CAMPAIGN: (state, payload) => {
      if (payload) {
        state.campaign = payload;
      }
    },
    POPULATE_PARENTS_COMPANY: (state, payload) => {
      if (payload) {
        state.parents_company = payload;
      }
    },
    POPULATE_SETTINGS: (state, payload) => {
      if (payload) {
        state.settings = payload;
      }
    },
  },
  namespaced: true,
  state: {
    campaign: null,
    customMessages: null,
    parents_company: null,
    settings: null,
  },
  strict: true,
};

CommonState.registerModule('company', module);
